import { redemptionAttempMaster } from "./Rewards.template";

export function getRedemptionAttempLabel(attemp?: string) {
  return !attemp ? undefined : redemptionAttempMaster[attemp];
}

export function formatPartnerLabel(partner: any): string {
  if (!partner) return '';
  if (typeof partner === 'string') return partner;
  const name = partner.name || partner.partner_name || '';
  const dirCode =
    partner.directory?.directory_code ||
    partner.directory_code ||
    partner.mall_code ||
    partner.directory?.code ||
    '';
  if (name && dirCode) {
    return `${name} (${dirCode})`;
  }
  if (partner.label) return partner.label;
  return name || dirCode || String(partner.id || partner.value || '');
}
